export enum RQueryKeys {
  ranking = 'ranking'
}
